"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useCiselnik_1 = __importDefault(require("../../../../hooks/useCiselnik"));
var Dropdown_1 = __importDefault(require("../../inputs/Dropdown"));
var OkresDropdown = function (_a) {
    var onChange = _a.onChange, value = _a.value, soudniKraj = _a.soudniKraj, enableReset = _a.enableReset, inputId = _a.inputId;
    var _b = useCiselnik_1.default('soudniOkresy'), loading = _b.loading, error = _b.error, data = _b.data;
    if (loading) {
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    }
    if (error) {
        return react_1.default.createElement("div", null, error);
    }
    var filterOptions = function () {
        if (soudniKraj)
            return data === null || data === void 0 ? void 0 : data.filter(function (o) { return o.idSoudniKraj === soudniKraj; });
        return data;
    };
    var options = (filterOptions() || []).map(function (item) { return ({ value: item.id, label: item.nazev }); });
    return (react_1.default.createElement(Dropdown_1.default, { placeholder: "Vyberte ze seznamu", name: "okres", value: value, onChange: onChange, loadOptions: function () { return Promise.resolve(options); }, enableReset: enableReset, inputId: inputId }));
};
OkresDropdown.defaultProps = {
    value: undefined,
    soudniKraj: undefined,
    enableReset: false,
    inputId: undefined,
};
exports.default = OkresDropdown;
